<template>
  <SideLayout :links="links" />
  <div id="root">
    <TopLayout :links="links" />
    <ContentLayout :links="links" />
  </div>
</template>

<script setup>
import TopLayout from '@/layouts/TopLayout.vue'
import SideLayout from '@/layouts/SideLayout.vue'
import ContentLayout from '@/layouts/ContentLayout.vue'


import { onMounted, reactive } from "vue"
import api from "@/utils/api.js"
const links = reactive({
  kakao: "#",
  telegram: "#",
  casino: "#",
  channels: [],
});

onMounted(async () => {

  try {
    const response = await api.get("/getLinks");
    Object.assign(links, response.data);

  } catch (err) {
    console.error(err);
  }

})
</script>
